/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomIcon } from 'datastake-daf/dist/components';
import Style from './style';
import Widget from '../../widget';
import { getConfig } from './config';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';

export default function MeetPeople({ title, data = {}, overview = {} }) {
  const { t } = useTranslation();
  const rowsConfig = getConfig(t, data)
  const image = (overview?.images || [])[0];

  return (
    <Widget
      className="with-border-header no-px"
      title={t('Mine Profile')}
    >
      <Style className='flex'>
        <div className='cont flex-1 pl-6'>
          <div className='image-cont'>
            <div
              className={formatClassname(['img', !image && 'empty'])}
              style={{ backgroundImage: `url('${image?.url || '/assets/images/dashboard/amp-dashboard/empty.png'}')` }}
            />
          </div>
        </div>

        <div className='cont flex-1'>
          <h4 className='pr-6'>{title}</h4>
          <p className='pr-6 flex-1'>
            {(data.description || '').split('\n').map((v, i) => (
              <React.Fragment key={i}>
                {v}
                <br />
              </React.Fragment>
            ))}
          </p>

          <div className='divider mr-6' />

          <div className='icons-rows pr-6'>
            {rowsConfig.map((row, i) => (
              <div className='item-row' key={`rows-${i}`}>
                {row.map((item, j) => (
                  <div className='item' key={`item-${j}-${i}`}>
                    <CustomIcon width={20} height={20} name={item.iconName} />
                    <span>{item.render()}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </Style>
    </Widget>
  )
}
